// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"b34193e4","252":"693f5ebd","320":"957a1e93","555":"6cf61093","648":"c2593a8c","833":"345f77ba","987":"d106bfa7"}[chunkId] + ".chunk.js";
};